import type { TFunction } from 'i18next';

import { make as makePassword } from './password';

const PASSWORD_MIN_LENGTH = 8;

const make = (t: TFunction) =>
  makePassword(t)
    .min(
      PASSWORD_MIN_LENGTH,
      t('passwordLengthTooShort', { count: PASSWORD_MIN_LENGTH }),
    )
    .matches(/[A-Z]/g, t('passwordMustContainAnUppercaseLetter'))
    .matches(/[0-9]/g, t('passwordMustContainANumber'));

export { make };
